import { useStocksQuery } from 'components/Stock/Stock.hooks';
import { FieldHookConfig, useField, useFormikContext } from 'formik';
import { useEffect } from 'react';
import { PrincipleFormValues } from './Principle.hooks';

export const CurrentPriceHiddenField = (props: FieldHookConfig<number>) => {
  const {
    values: { symbol },
    setFieldValue,
  } = useFormikContext<PrincipleFormValues>();
  const [field] = useField(props);
  const { data: stocks } = useStocksQuery('us');
  const targetStock = stocks.find((stock) => stock.symbol === symbol);

  useEffect(() => {
    if (symbol && targetStock) {
      setFieldValue(props.name, targetStock.regularMarketPrice);
    }
  }, [props.name, setFieldValue, symbol, targetStock]);

  return <input type="hidden" {...field} />
}
